require('jquery');
require('angularjs');
require('angularjs-route');
require('angularjs-sanitize');
